// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-upload[data-v-3f71a6fb] {\n  --magic-box-background: #2f3131;\n  --magic-dropdown-background: #1f2223;\n}\n\n.file-drop[data-v-3f71a6fb] {\n  background-color: #2f3131;\n}\n\n.files[data-v-3f71a6fb] {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.header[data-v-3f71a6fb] {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: var(--magic-light, #fff);\n}", ""]);
// Exports
module.exports = exports;
